import { useContext, useState, useEffect } from "react";
import { UserContext } from "./User";
import PopUpMessage from "./PopUpMessage";
import { NavLink, useNavigate } from "react-router-dom";
import ReactPlayer from "react-player/vimeo";
import Chevron from "../assets/chevron.svg";
import ConfettiComp from "./ConfettiComp";
import DATA from "./Data";
import { doc, updateDoc } from "firebase/firestore";
import db from "../firebase";
import Cookies from "js-cookie";

export default function Wallet() {
	const [badgeQuiz, setBadgeQuiz] = useState(false);
	const [badgeVideo, setBadgeVideo] = useState(false);
	const [badgeDownload, setBadgeDownload] = useState(false);
	const [companyName, setCompanyName] = useState("");
	const [badgeCompany, setBadgeCompany] = useState(false);
	const [popup, setPopup] = useState(false);
	const [popupAdd, setPopupAdd] = useState("");
	const [popupEmoji, setPopupEmoji] = useState("");
	const [popupHeading, setPopupHeading] = useState("");
	const [popupContent, setPopupContent] = useState("");
	const [popupText, setPopupText] = useState("");
	const [classChange, setClassChange] = useState(false);
	const [modalOpen, setModalOpen] = useState(false);
	const [showDetails, setShowDetails] = useState(false);
	const [fire, setFire] = useState(false);
	const { user, setUser } = useContext(UserContext);
	const [rewards, setRewards] = useState(user.rewards);
	const navigate = useNavigate();

	const classChanger = (e, heading) => {
		setPopupContent(e.target["src"]);
		setPopupHeading(heading);
		setClassChange(!classChange);
		setPopup(true);
		if (heading === "Avatar") {
			setPopupText("Your unique avatar has been unlocked.");
			setPopupAdd("");
			// } else if (heading === "Social") {
			// 	setPopupText(
			// 		`Thank you for following us on Instagram`
			// 	);
			// 	setPopupEmoji("🗣️")
			// 	setPopupText("Visit our Instagram profile");
			// 	setPopupAdd(
			// 		<button className="download-btn" onClick={handleClickSocial}>
			// 			Go to instagram
			// 		</button>
			// 	);
			// } else if (heading === "Poll") {
			// 	setPopupText(
			// 		`Your favorite use of a premium apple is ${user.progress.packet_1.activities.poll.answer}`
			// 	);
			// 	if (user.progress.packet_1.activities.poll.answer === "Dessert") {
			// 		setPopupEmoji("🧁");
			// 	} else if (user.progress.packet_1.activities.poll.answer === "Light Mains") {
			// 		setPopupEmoji("🥙");
			// 	} else if (user.progress.packet_1.activities.poll.answer === "Salads") {
			// 		setPopupEmoji("🥗");
			// 	} else if (user.progress.packet_1.activities.poll.answer === "Pairings") {
			// 		setPopupEmoji("🍷");
			// 	}
			// 	setPopupAdd("");
		} else if (heading === "Quiz") {
			setPopupText(
				`Your primary goal with live events is ${user.progress.packet_1.activities.quiz.answer}`
			);
			setPopupEmoji("🎯");
			setPopupAdd("");
		} else if (heading === "Mint") {
			setPopupText("You can also access your minted NFT in Solana");
			setPopupAdd("");
		} else if (heading === "Free drink") {
			setPopupContent(
				"https://ucarecdn.com/26395a81-c280-4b16-8ebd-ecfaea465ae9/-/crop/1632x917/0,0/-/preview/-/quality/lighter/-/format/auto/-/scale_crop/1920x1080/center/"
			);
			setPopupText("Follow given instructions to redeem the code");
		} else if (heading === "PDF") {
			setPopupEmoji("📄");
			setPopupText("You can view your pdf again here: ");
			setPopupAdd(
				<button className="download-btn" onClick={handleClickDownload}>
					View PDF
				</button>
			);
		} else if (heading === "Video") {
			setPopupEmoji("🎥");
			setPopupText("Watch your video again");
			setPopupAdd(
				<div className="video-wrapper">
					<ReactPlayer
						controls
						config={{
							vimeo: {
								playerOptions: {
									autoplay: false,
									background: false,
								},
							},
						}}
						width="100%"
						height="165%"
						url="https://vimeo.com/738487002"
					/>
				</div>
			);
		} else if (heading === "Company") {
			setPopupText("");
			setPopupAdd(
				<div>
					<div className="company-details">
						Your company is <span id="company-name">{user.companyName}</span>
					</div>
					<div className="company-details">
						Your corporate email is: {user.corporateEmail}
					</div>
				</div>
			);
			setPopupEmoji("🏢");
		} else if (heading === "reward-one") {
			setPopupHeading('$1000 Notion credit');
			setPopupText(
				"Signup using this link https://www.notion.so/startups"
			);
			setPopupEmoji("🎁");
		} else if (heading === "reward-two") {
			setPopupHeading('Your personalized AI gift');
			setPopupText(
				"Allow a few days for it to appear in your wallet."
			);
			setPopupEmoji("🎁");
		}
	};

	const handleClickFromProfile = () => {
		if (document.getElementsByClassName("wallet-activities").length !== 0) {
			navigate("/profile");
		}
	};

	const handleClickDownload = () => {
		setFire(true);
		setPopup(false);
		window.open(
			"https://firebasestorage.googleapis.com/v0/b/lagoon-118b4.appspot.com/o/lagoon.pdf?alt=media&token=e6fa23be-c233-4228-bbea-aa9b3afb5ea0",
			"_blank",
			"fullscreen=yes"
		);
	};

	const redeemGift = async (reward) => {
		setFire(true);
		setTimeout(() => {
			setPopup(false);
		}, 1500);
		const user_ref = await doc(db, "users", Cookies.get().id);
		reward === "one"
			? await updateDoc(user_ref, {
					"rewards.reward_one.redeemed": true,
			  })
			: await updateDoc(user_ref, {
					"rewards.reward_two.redeemed": true,
			  });
	};

	useEffect(() => {
		if (user.progress) {
			const userProgress1 = user.progress["packet_1"];
			const userProgress2 = user.progress["packet_2"];
			if (userProgress1) {
				if (userProgress1.activities.quiz.completed) {
					setBadgeQuiz(true);
				}
				if (userProgress1.activities.video.completed) {
					setBadgeVideo(true);
				}
				if (userProgress2.activities.pdf.completed) {
					setBadgeDownload(true);
				}
				if (userProgress2.activities.bio.completed) {
					setBadgeCompany(true);
				}
			}
		}
	}, [user.progress]);

	// useEffect(() => {
	// 	if (classChange) {
	// 		setPopup(true);
	// 	} else {
	// 		setPopup(false);
	// 	}
	// }, [classChange]);

	function onModalChange(newState) {   
		setPopup(newState);
	}

	return (
		<div className="wallet">
			<div className="wallet-flex" onClick={handleClickFromProfile}>
				{user.avatarRevealed ? (
					<div
						onClick={(e) => classChanger(e, "Avatar")}
						className="wallet-card"
						id="new-avatar"
					>
						<img className="wallet-image" src={user.avatarUrl} alt="" />
					</div>
				) : (
					""
				)}
				{user.logoRevealed ? (
					<div
						onClick={(e) => classChanger(e, "Mint")}
						className="wallet-card"
						id="mint"
					>
						<img className="wallet-image" src={`${user.logoUrl}`} alt="" />
					</div>
				) : (
					""
				)}
				{/* {badgeSocial ? (
							<div
								onClick={(e) => classChanger(e, "Social")}
								className="wallet-card activity-nft"
								id="social"
							>
								<p>Social</p>
								<div className="emoji">🗣️</div>
							</div>
						) : (
							""
						)} */}
				{/* {badgePoll ? (
							<div
								onClick={(e) => classChanger(e, "Poll")}
								className="wallet-card activity-nft"
								id="poll"
							>
								<p>Poll</p>
								{user.progress.packet_1.activities.poll.answer === "Dessert" ? (
									<div className="emoji">🧁</div>
								) : ("") }
								{user.progress.packet_1.activities.poll.answer === "Light Mains" ? (
									<div className="emoji">🥙</div>
								) : ("") }
								{user.progress.packet_1.activities.poll.answer === "Salads" ? (
									<div className="emoji">🥗</div>
								) : ("") }
								{user.progress.packet_1.activities.poll.answer === "Pairings" ? (
									<div className="emoji">🍷</div>
								) : ("") }
							</div>
						) : (
							""
						)} */}
				{badgeQuiz ? (
					<div
						onClick={(e) => classChanger(e, "Quiz")}
						className="wallet-card activity-nft"
						id="quiz"
					>
						<p>Quiz</p>
						<div className="emoji">🎯</div>
					</div>
				) : (
					""
				)}
				{badgeCompany ? (
					<div
						onClick={(e) => classChanger(e, "Company")}
						className="wallet-card activity-nft"
						id="bio"
					>
						<p>{companyName}</p>
						<div className="emoji">🏢</div>
					</div>
				) : (
					""
				)}
				{badgeVideo ? (
					<div
						onClick={(e) => classChanger(e, "Video")}
						className="wallet-card activity-nft"
						id="mint"
					>
						<p>Video</p>
						<div className="emoji">🎥</div>
					</div>
				) : (
					""
				)}
				{badgeDownload ? (
					<div
						onClick={(e) => classChanger(e, "PDF")}
						className="wallet-card activity-nft"
						id="mint"
					>
						<p>PDF</p>
						<div className="emoji">📄</div>
					</div>
				) : (
					""
				)}
				{user.drinkRedeemed ? (
					<div
						onClick={(e) => classChanger(e, "Drink voucher")}
						className="wallet-card"
						id="voucher"
					>
						<p>Drink code: </p>
						<p className={``}>{voucher}</p>
						{/* <button className={``} onClick={voucherUsed}>
									Use it
								</button> */}
						<div className="emoji">🥂</div>
					</div>
				) : (
					""
				)}

				{rewards
					? Object.values(rewards).map((reward, i) => {
							if (reward.redeemed) {
								const img = "/img/" + reward.image;
								return (
									<div
										key={reward.id}
										className="wallet-card activity-nft reward"
										onClick={(e) => classChanger(e, reward.id)}
									>
										<p className="reward-name">{reward.name}</p>
										<img className="emoji" src={img} width="70%" />
									</div>
								);
							}
					  })
					: ""}
				<NavLink className="wallet-button" to="/profile">
					{/* <div className="wallet-link">Go to wallet</div> */}
					<img className="wallet-svg" src={Chevron}></img>
					{/* <img className="wallet-svg" src={WalletSvg}></img> */}
					{/* <button className="business-card-btn my-collectables">
						View my collectibles
					</button> */}
				</NavLink>
			</div>

			<ConfettiComp fire={fire} />
			<PopUpMessage trigger={popup} onModalChange={onModalChange}>
				{
					<>
						<div
							className={`wallet-card ${!showDetails ? "" : "hide-details"}`}
						>
							{popupContent ? (
								<img className="wallet-image" src={popupContent} alt="" />
							) : (
								<div className="emoji">{popupEmoji}</div>
							)}
						</div>
						<div className={`flip-side ${!showDetails ? "" : "hide-details"}`}>
							<h2>{popupHeading} details: </h2>
							<div className="popup-text">{popupText}</div>
							{popupAdd}
						</div>
						{/* <button className="show-details" onClick={handleShowDetails}>
								{buttonForDetails}
							</button> */}
					</>
				}
			</PopUpMessage>
		</div>
	);
}
